<template>
  <v-select
    class="mx-1 rounded-lg"
    color="primary"
    dense
    outlined
    style="width: 100px;"
    hide-details
    :items="languages"
    @change="languageChanged()"
    v-model="$i18n.locale"
  >
  </v-select>
</template>

<script>
import i18n from "@/services/i18n";
//import maxios from "@/services/mediligo-axios";
import en from "vuetify/lib/locale/en"
import nl from "vuetify/lib/locale/nl"
import fr from "vuetify/lib/locale/fr"

export default {
  i18n: i18n,
  name: 'm2h-locale-changer',
  props: ['activePage', 'currentUser'],
  data: function () {
    return {
      languages: ['nl', 'en', 'fr'],
      shouldReloadPages: [
          'Me',
          'Events',
          'News',
          'Bio Age'
      ],
      cUser: {}
    }
  },

  mounted(){
    this.$vuetify.lang.locales = { en, nl, fr }
    if (this.currentUser){
      this.cUser = JSON.parse(JSON.stringify(this.currentUser))
    }
    this.init()
  },

  methods: {
    async init(){
      // Check for language parameter in url
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      if(urlParams.get('lang')){
        this.$i18n.locale = this.languages.includes(urlParams.get('lang')) ? urlParams.get('lang') : 'en'
        this.$vuetify.lang.current = this.languages.includes(urlParams.get('lang')) ? urlParams.get('lang') : 'en'
        this.$moment.locale(this.languages.includes(urlParams.get('lang')) ? urlParams.get('lang') : 'en')
        localStorage.setItem('Lang', this.$i18n.locale)
        return
      }
      
      
      /*if (this.currentUser){
        if (!this.cUser.MetaData) {
          this.cUser.MetaData = {}
        }
        if (
          this.languages.includes(this.cUser.MetaData.Language)){
          this.$i18n.locale = this.cUser.MetaData.Language
          this.$vuetify.lang.current = this.cUser.MetaData.Language
          this.$moment.locale(this.cUser.MetaData.Language)
          localStorage.setItem('Lang', this.$i18n.locale)
        }

        if (!this.languages.includes(this.cUser.MetaData.Language)){
          this.$i18n.locale = this.currentUser.MetaData.Language
          this.$vuetify.lang.current = this.cUser.MetaData.Language
          this.$moment.locale(this.cUser.MetaData.Language)
          localStorage.setItem('Lang', this.$i18n.locale)
          this.cUser.MetaData.Language = this.$i18n.locale;
          //await maxios.put('/api/MediligoProfile', this.cUser);
        }
      }*/

      let storage = localStorage.getItem('Lang')
      
      if (storage && this.languages.includes(storage)){
        this.$i18n.locale = storage
        this.$vuetify.lang.current = storage
        this.$moment.locale(storage)
      }

      if (!storage){
        let navLang = navigator.language.substring(0,2)
        
        this.$i18n.locale = this.languages.includes(navLang) ? navLang : 'en'
        this.$vuetify.lang.current = this.languages.includes(navLang) ? navLang : 'en'
        this.$moment.locale(this.languages.includes(navLang) ? navLang : 'en')
        localStorage.setItem('Lang', this.$i18n.locale)
      }
    },

    async languageChanged() {
      if (this.shouldReloadPages.includes(this.activePage)){
        this.$root.$emit('m2h-loader-show');
        await this.changeLanguage()
        window.location.reload()
      } else {
        await this.changeLanguage()
      }
      this.$root.$emit('language-changed')
    },

    async changeLanguage(){
      this.$moment.locale(this.$i18n.locale)
      this.$vuetify.lang.current = this.$i18n.locale
      localStorage.setItem('Lang', this.$i18n.locale)
      /*if (!this.cUser.MetaData) {
        this.cUser.MetaData = {}
      }
      this.cUser.MetaData.Language = this.$i18n.locale;*/
      //await maxios.put('/api/MediligoProfile', this.cUser);
    }
  }
}
</script>
